const MAX_PRODUCTS = 3;

// PDP Compare productionalized experiences (formerly AB test #3738 challengers, now resolved by locale + device).
const SIMPLIFIED_PDP_COMPARE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour'
};

export {
    MAX_PRODUCTS, SIMPLIFIED_PDP_COMPARE
};
